import ISignInForm from "../../models/view/signIn/ISignInForm";
import {createField} from "../../factories/fieldFactory";
import {createValidationWithMessage, validateHasAnyValue,} from "../validation/validation";
import {appRoutePaths} from "../../config/config";
import SignInInvalidPasswordError from "../../client/errors/SignInInvalidPasswordError";
import SignInInvalidUsernameError from "../../client/errors/SignInInvalidUsernameError";
import {navigate} from "../navigation/navigation";
import {createEventBusAndHook} from "../eventBus/common";
import TooManyFailedLoginAttempts from "../../client/errors/TooManyFailedLoginAttempts";
import productMonitoring from "../log/productMonitoring";
import {userAuthentication} from "../user/authentication";
import {logger} from "../log/logger";

class SignIn{
  signInForm = createSignInForm();
  loadingHook = createLoadingHook();


  useSignInForm(){
    return this.signInForm;
  }
  useLoadingHook(){
    return this.loadingHook.loadingHook();
  }
  async signInUsingSignInForm(searchParams: URLSearchParams) {
    // Guard: Make sure form data is valid
    const isValid = validatateSignInForm(this.signInForm);
    if(!isValid) {
      return;
    }

    this.loadingHook.emitLoadingChanged({isLoading: true});

    const {username, password} = getValuesFromSignInForm(this.signInForm);

    try {
      void await userAuthentication.signIn(username, password);
      const routeLocationAfterSignIn = searchParams.get("route-to-page-after-sign-in");
      navigate(routeLocationAfterSignIn ?? appRoutePaths.firstPageAfterSignIn);

    } catch(e) {
      const error = e as Error;

      if(e instanceof SignInInvalidPasswordError) {
        this.signInForm.password.error.isInErrorState = true;
        this.signInForm.password.error.errorMessages = [e.message];
        this.signInForm.password.emitMessage({...this.signInForm.password});

      } else if(e instanceof SignInInvalidUsernameError || e instanceof TooManyFailedLoginAttempts) {
        this.signInForm.username.error.isInErrorState = true;
        this.signInForm.username.error.errorMessages = [e.message];
        this.signInForm.username.emitMessage({...this.signInForm.username});

      } else {
        logger.userAuth.error({message: error.message});
        this.signInForm.username.error.isInErrorState = true;
        this.signInForm.username.error.errorMessages = [error.message];
        this.signInForm.username.emitMessage({...this.signInForm.username});
        productMonitoring.logException(error);
      }
    }

    this.loadingHook.emitLoadingChanged({isLoading: false});
  }
}
interface ILoading{
  isLoading: boolean;
}
function createLoadingHook(){
  const {use: loadingHook, emitMessage: emitLoadingChanged} = createEventBusAndHook<ILoading>({isLoading: false});
  return {loadingHook, emitLoadingChanged};
}

function validatateSignInForm(signInForm: ISignInForm){
  const isUsernameValid = signInForm.username.validate();
  const isPasswordValid = signInForm.password.validate();
  return isPasswordValid && isUsernameValid;
}

function getValuesFromSignInForm(signInForm: ISignInForm){
  return {
    username: signInForm.username.value,
    password: signInForm.password.value,
  }
}

function createSignInForm(){
  const form: ISignInForm = {
    username: createField("", [createValidationWithMessage(validateHasAnyValue, "Username must contain at least one character")]),
    password: createField("", [createValidationWithMessage(validateHasAnyValue, "Password must contain at least one character")]),
  };
  return form;
}

const signIn = new SignIn();
export default signIn;